import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct;

export interface ProductDetailsManufacturingPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const manufacturingPartNumberStyles: ProductDetailsManufacturingPartNumberStyles = {
    labelText: {
        // Store Removed Code - size
        // Store Removed Code - weigth
        css: css`
            /* Store Custom Code - Start */
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["0", null, "10px", null, null], properties: ["margin-left"] }],
                    mediaOptions.min,
                )}

            &::before {
                content: "|";
                margin-right: 12px;
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["none", null, "inline", null, null], properties: ["display"] }],
                        mediaOptions.min,
                    )}
            }
            /* Store Custom Code - End */
        `,
    },
    valueText: {
        // Store Removed Code - size
        css: css`
            /* Store Custom Code - Start */
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["block", null, "inline", null, null], properties: ["display"] }],
                    mediaOptions.min,
                )}/* Store Custom Code - End */
        `,
    },
};

const styles = manufacturingPartNumberStyles;

const ProductDetailsManufacturingPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.manufacturerItem) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="p">
            <Typography {...styles.labelText}>{translate("MFG #")}</Typography>
            {product.manufacturerItem}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsManufacturingPartNumber),
    definition: {
        displayName: "Manufacturing Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
